import useUDGroups from "hooks/UD/useUDGroups";
import Button from "components/Button";

export default function RevertGrouping({ params, onChange }) {
   
   const { d: groups } = useUDGroups( params.edition );

   return params.grouping_variable_ids?.length === 2 ?
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px 30px", alignItems: "center" }}>
         <div> <strong>Zmienna grupująca:</strong> { groups?.find( i => i.value === params.grouping_variable_ids[0])?.label } </div>
         <div> <strong>Zmienna na wykresie:</strong> { groups?.find( i => i.value === params.grouping_variable_ids[1])?.label} </div>

         <Button 
            label="Odwróć"
            extra_classes="violet"
            onClick={() => {
               const [ first, second ] = params.grouping_variable_ids;
               onChange({ grouping_variable_ids: [ second, first ]});
            }}
         />
      </div> : null
}